'use strict';

(function () {
	const SA_PROJECT = {
		test: 'default',
		pre: 'pre_release',
		prod: 'production',
	};
	const SERVER_URL = 'https://prod-us-datalink.arnoo.com/sa';

	const defaultOptions = {
		showLog: config.RTE === 'test',
	};

	class Tracer {
		constructor(options) {
			this.sa = null;
			this.options = Object.assign({}, defaultOptions, options);
			this.store = new Map();
			this.store.set('timeOrigin', new Date(performance.timeOrigin));
		}

		initSDK(sensors) {
			if (!this.sa && sensors && sensors.init) {
				const u = window.app.user || {};
				const server_url = `${SERVER_URL}?project=${SA_PROJECT[config.RTE] || SA_PROJECT.test}`;
				const platform_type = /(iphone|ipad|android)/i.test(window.navigator.userAgent) ? 'Mobile Web' : 'PC Web';
				sensors.init({
					server_url,
					show_log: this.options.showLog,
					use_client_time: true,
					send_type: 'beacon',
					is_track_single_page: true,
					heatmap: {
						clickmap: 'default',
						scroll_notice_map: 'default',
					},
				});
				sensors.registerPage({
					platform_type,
					app_name: 'AiDot Community',
					is_login: !!u.uid,
					is_vip: !!u.vip,
				});
				sensors.quick('autoTrack');
				sensors.quick('isReady', () => {
					const preset_properties = sensors.getPresetProperties();
					this.store.set('preset_properties', preset_properties);

					this.sa = sensors;
				});
				sensors.use('PageLeave');
				if (u.uid) {
					sensors.loginWithKey('$identity_login_id', u.app_user_id || u.uid);
				}
			}
		}

		ready() {
			if (this.sa) {
				if (this._sa_promise) {
					delete this._sa_promise;
				}
				return Promise.resolve(this.sa);
			} else if (this._sa_promise) {
				return this._sa_promise;
			}

			this._sa_promise = new Promise((reslove, reject) => {
				if (require) {
					require(['sa'], (sa) => {
						this.initSDK(sa);
						reslove(sa);
					});
				} else {
					reject(new Error('can\'t load sdk.'));
				}
			});
			return this._sa_promise;
		}

		track(event, data) {
			if (arguments.length > 0) {
				this.ready().then((sensors) => {
					sensors.track(event, data);
				});
			}
		}

		setUserProfile(data) {
			if (arguments.length > 0) {
				this.ready().then((sensors) => {
					sensors.setProfile(data);
				});
			}
		}
	}

	const tracer = new Tracer({
		showLog: config.RTE === 'test',
	});

	window.tracer = tracer;
}());
